import React from 'react';
import styled from 'styled-components';
import { SCol, SRow, SIcon } from '@avalara/skylab-sdk/react';
import { formatPrice } from '../../../../shared/helpers';
const InlineSpanContainer = styled.div `
  display: inline-flex;
  span {
    display: inline-flex;
    align-items: center;
    margin-left: 5px;
  }
`;
const Discount = ({ currency, discountName, discountAmount, showDiscountedSubTotal, subtotal }) => (React.createElement(React.Fragment, null,
    React.createElement(SRow, { className: 'margin-top-xs' },
        React.createElement(SCol, { span: '8', className: 'hide-overflow' },
            React.createElement("span", { className: 'pad-right-sm' }, "Discount"),
            discountName &&
                React.createElement("span", { className: 'no-wrap', title: discountName },
                    React.createElement(SIcon, { name: 'tag', "aria-hidden": 'true', className: 'pad-right-xs' }),
                    discountName)),
        React.createElement(SCol, { span: '4', className: 'text-right align-self-start' },
            React.createElement(InlineSpanContainer, null,
                React.createElement("span", null,
                    "- ",
                    discountAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }))))),
    showDiscountedSubTotal && React.createElement(SRow, null,
        React.createElement(SCol, { span: 'xl-10 lg-10 6', className: 'align-self-end' }, "Your price"),
        React.createElement(SCol, { span: 'xl-2 lg-2 4', className: 'text-right' },
            React.createElement("hr", { className: 'pad-bottom-sm' }),
            React.createElement(InlineSpanContainer, null,
                React.createElement("span", null, formatPrice(subtotal, 2, currency)))))));
export default Discount;
